import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getProductBasic } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.GET.BASIC,
  api: getProductBasic,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/products/GetBasicAction.js